import React from "react";

function FullSizeGuideContent({ sizeGuideData, isFullSize, viewFullSizeCb }) {
  if (!isFullSize) return null;

  let fullSizeChartData = sizeGuideData.full_size_chart || {};
  let fullSizeChart = [];
  let tempKidsFullSizeChart = [] ;
  let kidsFullSizeChart = [] ; 

  for (let mainCat in fullSizeChartData) {

    if( mainCat === "MEN"  || mainCat === "WOMEN" ){
      let chartItem = { title: mainCat, items: [] };
      let mainCatItems = fullSizeChartData[mainCat];
      for (let subCat in mainCatItems) {
        chartItem.items.push({ title: subCat, ...mainCatItems[subCat] });
      }
  
      fullSizeChart.push(chartItem);
    }else{

      let chartItem = { title: mainCat, items: [] };
      let mainCatItems = fullSizeChartData[mainCat];
      for (let subCat in mainCatItems) {
        chartItem.items.push({ title: subCat, ...mainCatItems[subCat] });
      }
  
      tempKidsFullSizeChart.push(chartItem);
    }

  }
  kidsFullSizeChart.push({ title: 'KIDS', items: tempKidsFullSizeChart || []});


  return (
    <>
      <div className="accordion" id="sizeGuideFullMain">
        {sizeGuideData && sizeGuideData?.full_size_chart && (
          <>
            {fullSizeChart.map((mainCat, mainIndex) => {
              return (
                <div className="accordion-item" key={mainIndex}>
                  <h2
                    className="accordion-header"
                    id={`sizeGuide_${mainIndex}`}
                  >
                    <button
                      className="accordion-button text-underline collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#sizeGuide_${mainIndex}_collapse`}
                      aria-expanded="false"
                      aria-controls={`sizeGuide_${mainIndex}_collapse`}
                    >
                      {mainCat.title}
                    </button>
                  </h2>
                  <div
                    id={`sizeGuide_${mainIndex}_collapse`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`sizeGuide_${mainIndex}`}
                    data-bs-parent="#sizeGuideFullMain"
                  >
                    <div className="accordion-body">
                      <div
                        className="accordion"
                        id={`sizeGuide_${mainIndex}_inner`}
                      >
                        {mainCat.items.map((innerCat, innerIndex) => {
                          return (
                            <div className="accordion-item" key={innerIndex}>
                              <h2
                                className="accordion-header"
                                id={`sizeGuide_${mainIndex}_${innerIndex}`}
                              >
                                <button
                                  className="accordion-button text-grey collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#sizeGuide_${mainIndex}_${innerIndex}_collapse`}
                                  aria-expanded="true"
                                  aria-controls={`sizeGuide_${mainIndex}_${innerIndex}_collapse`}
                                >
                                  {innerCat.title}
                                </button>
                              </h2>
                              <div
                                id={`sizeGuide_${mainIndex}_${innerIndex}_collapse`}
                                className="accordion-collapse collapse"
                                aria-labelledby={`sizeGuide_${mainIndex}_${innerIndex}`}
                                data-bs-parent={`#sizeGuide_${mainIndex}_inner`}
                                data-parent={`#sizeGuide_${mainIndex}_inner`}
                              >
                                <div className="accordion-body">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <div className="table-responsive mt-25">
                                        <table className="table text-center">
                                          <thead>
                                            <tr>
                                              {innerCat.row_header_text.map(
                                                (header, hIndex) => {
                                                  return (
                                                    <th key={hIndex}>
                                                      {header}
                                                    </th>
                                                  );
                                                }
                                              )}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {innerCat.row_data.map(
                                              (row, rIndex) => {
                                                return (
                                                  <tr key={rIndex}>
                                                    {row.map(
                                                      (rowData, rdIndex) => {
                                                        return (
                                                          <td key={rdIndex}>
                                                            {rowData}
                                                          </td>
                                                        );
                                                      }
                                                    )}
                                                  </tr>
                                                );
                                              }
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}


            {kidsFullSizeChart.map((mainCat, mainIndex) => {
              return (
                <div className="accordion-item" key={mainIndex+'kids'}>
                  <h2
                    className="accordion-header"
                    id={`sizeGuide_${mainIndex+'kids'}`}
                  >
                    <button
                      className="accordion-button text-underline collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#sizeGuide_${mainIndex+'kids'}_collapse`}
                      aria-expanded="false"
                      aria-controls={`sizeGuide_${mainIndex+'kids'}_collapse`}
                    >
                      {mainCat.title}
                    </button>
                  </h2>
                  <div
                    id={`sizeGuide_${mainIndex+'kids'}_collapse`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`sizeGuide_${mainIndex+'kids'}`}
                    data-bs-parent="#sizeGuideFullMain"
                  >
                    <div className="accordion-body">
                      <div
                        className="accordion"
                        id={`sizeGuide_${mainIndex+'kids'}_inner`}
                      >

                      {mainCat.items.map((mainCatsub, mainIndexsub) => {
                                    return (
                                      <div className="accordion-item" key={mainIndexsub+'subkids'}>
                                        <h2
                                          className="accordion-header"
                                          id={`sizeGuide_${mainIndexsub+'subkids'}`}
                                        >
                                          <button
                                            className="accordion-button text-underline collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#sizeGuide_${mainIndexsub+'subkids'}_collapse`}
                                            aria-expanded="false"
                                            aria-controls={`sizeGuide_${mainIndexsub+'subkids'}_collapse`}
                                          >
                                            {mainCatsub.title}
                                          </button>
                                        </h2>
                                        <div
                                          id={`sizeGuide_${mainIndexsub+'subkids'}_collapse`}
                                          className="accordion-collapse collapse"
                                          aria-labelledby={`sizeGuide_${mainIndexsub+'subkids'}`}
                                          data-bs-parent={`#sizeGuide_${mainIndex+'kids'}_inner`}
                                        >
                                          <div className="accordion-body">
                                            <div
                                              className="accordion"
                                              id={`sizeGuide_${mainIndexsub+'subkids'}_inner`}
                                            >
                                              {mainCatsub.items.map((innerCat, innerIndex) => {
                                                return (
                                                  <div className="accordion-item" key={innerIndex}>
                                                    <h2
                                                      className="accordion-header"
                                                      id={`sizeGuide_${mainIndexsub+'subkids'}_${innerIndex}`}
                                                    >
                                                      <button
                                                        className="accordion-button text-grey collapsed"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#sizeGuide_${mainIndexsub+'subkids'}_${innerIndex}_collapse`}
                                                        aria-expanded="true"
                                                        aria-controls={`sizeGuide_${mainIndexsub+'subkids'}_${innerIndex}_collapse`}
                                                      >
                                                        {innerCat.title}
                                                      </button>
                                                    </h2>
                                                    <div
                                                      id={`sizeGuide_${mainIndexsub+'subkids'}_${innerIndex}_collapse`}
                                                      className="accordion-collapse collapse"
                                                      aria-labelledby={`sizeGuide_${mainIndexsub+'subkids'}_${innerIndex}`}
                                                      data-bs-parent={`#sizeGuide_${mainIndexsub+'subkids'}_inner`}
                                                      data-parent={`#sizeGuide_${mainIndexsub+'subkids'}_inner`}
                                                    >
                                                      <div className="accordion-body">
                                                        <div className="row">
                                                          <div className="col-md-12">
                                                            <div className="table-responsive mt-25">
                                                              <table className="table text-center">
                                                                <thead>
                                                                  <tr>
                                                                    {innerCat.row_header_text.map(
                                                                      (header, hIndex) => {
                                                                        return (
                                                                          <th key={hIndex}>
                                                                            {header}
                                                                          </th>
                                                                        );
                                                                      }
                                                                    )}
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {innerCat.row_data.map(
                                                                    (row, rIndex) => {
                                                                      return (
                                                                        <tr key={rIndex}>
                                                                          {row.map(
                                                                            (rowData, rdIndex) => {
                                                                              return (
                                                                                <td key={rdIndex}>
                                                                                  {rowData}
                                                                                </td>
                                                                              );
                                                                            }
                                                                          )}
                                                                        </tr>
                                                                      );
                                                                    }
                                                                  )}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                      })}
                        
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}





          </>
        )}
      </div>

      <div className="row">
        <div className="col-md-10 mx-auto">
          <div className="bt-blck"></div>
        </div>
        <div className="col-md-8 mx-auto">
          <div className="disclaimer-text">
            <p className="text-black">{sizeGuideData?.help_subtitle_text || ""}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default FullSizeGuideContent;
